module.exports = __webpack_public_path__ + "static/media/cloudinary.6a4cf930.png";